import { Component, OnInit, Input } from '@angular/core';
import { DurationDataElement } from '../../../core/elements/models/duration-data-element.model';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SimulatorEngineService } from '../../../core/services/simulator-engine.service';
import { Subscription } from 'rxjs';
import { SimulatorCommunicationService } from '../../shared/services/simulator-communication.service';


@Component({
  selector: 'acr-assist-duration-element',
  template: `<form [formGroup]="durationElementForm" novalidate>
  <div class="form-group">
    <div class="col-sm-5 text-right">
      <label class="control-label break-word">
        <!-- {{dateTimeDataElement | json}} -->
        {{durationDataElement.label}}
        <span *ngIf="durationDataElement.unit != undefined && durationDataElement.unit != ''">
          ({{durationDataElement.unit}})</span>
      </label>
      <ng-container *ngIf="durationDataElement.hint !== '' && durationDataElement.hint !== undefined">
        <i class="fa fa-info-circle text-primary whitespace" title="{{durationDataElement.hint}}"></i>
      </ng-container>
      <!-- <ng-container *ngIf="durationDataElement.diagrams != undefined ">
        <acr-hint-diagram [dataElement]="durationDataElement" [imagePath]="imagePath"></acr-hint-diagram>
      </ng-container> -->

      <!-- <ng-container *ngIf="this.durationDataElement.isRequired">      
        <span *ngIf="DurationVal == 'PT0S' || DurationVal == null" class="required-field" title="Duration field should be non zero">
          *
        </span>
      </ng-container> -->
      <ng-container *ngIf="this.durationDataElement.isRequired
      && (!showdayminValidation && !showdaymaxValidation && !showminuteminValidation
           && !showminutemaxValidation && !showhourminValidation && !showhourmaxValidation)">
        <span *ngIf="durationElementForm.controls['durationdayselement'].invalid
         || durationElementForm.controls['durationminuteselement'].invalid
         || durationElementForm.controls['durationhourselement'].invalid">
          <span *ngIf="durationElementForm.controls['durationdayselement'].errors != null && durationElementForm.controls['durationdayselement'].errors.required 
          || durationElementForm.controls['durationminuteselement'].errors != null && durationElementForm.controls['durationminuteselement'].errors.required 
          ||  durationElementForm.controls['durationhourselement'].errors != null && durationElementForm.controls['durationhourselement'].errors.required "
            class="required-field" title="Required Field">
            *
          </span>
        </span>
      </ng-container>      

      <span *ngIf="showdayminValidation"
        class="required-field" title=" Minimum value for day is {{supportedUnits['day'].min}}">
        *
      </span>
      
      <span *ngIf="showdaymaxValidation"
        class="required-field" title=" Maximum value for day is {{supportedUnits['day'].max}}">
        *
      </span>

      <span *ngIf="showminuteminValidation"
        class="required-field" title=" Minimum value for minute is {{supportedUnits['minute'].min}}">
        *
      </span>
      <span *ngIf="showminutemaxValidation"
        class="required-field" title=" Maximum value for minute is {{supportedUnits['minute'].max}}">
        *
      </span>

      <span *ngIf="showhourminValidation"
        class="required-field" title=" Minimum value for hour is {{supportedUnits['hour'].min}}">
        *
      </span>
      <span *ngIf="showhourmaxValidation"
        class="required-field" title=" Maximum value for hour is {{supportedUnits['hour'].max}}">
        *
      </span>
    </div>

    <div class="col-sm-7" style="display:inline-flex">
      <!-- <div [ngClass]="durationDataElement.isEditable == false ? 'disabled-picker' : ''">
        <ngx-duration-picker min="0" formControlName="durationElement" [options]="durationOptions" [(value)]="DurationVal"></ngx-duration-picker>
      </div> -->


      <!-- <div class="form-group"> -->
      <div [ngClass]="durationDataElement.isEditable == false ? 'disabled-picker' : ''">
        <table>
          <tbody>
            <!-- <tr class="text-center">
              <td>
                <button type="button" (click)="increaseValue('days')" class="btn btn-link btn-decrementer">
                  +
                </button>
              </td>
            </tr> -->
            <tr class="text-center">
              <td class="input-group input-group-sm">
                <input tabindex="1" [attr.disabled]="durationDataElement.isEditable == false ? 'disabled' : null"
                  formControlName="durationdayselement" [(ngModel)]="daysvalue" class="form-control text-center txt-duration"
                  (blur)="checkValue($event, 'days')" type="number" min="{{supportedUnits['day'].min}}" max="{{supportedUnits['day'].max}}"
                  (keypress)="onlyInteger($event)" onpaste="return false;" required />
                <span class="input-group-addon" style="padding: 5px;">{{supportedUnits['day'].label}}</span>
              </td>
            </tr>
            <!-- <tr class="text-center">
              <td>
                <button type="button" (click)="decreaseValue('days')" class="btn btn-link btn-decrementer">
                  -
                </button>
              </td>
            </tr> -->
          </tbody>
        </table>
      </div>

      <table style="margin-left:10px;">
        <tbody>
          <!-- <tr class="text-center">
            <td>
              <button type="button" (click)="increaseValue('hour')" class="btn btn-link btn-incrementer">
                +
              </button>
            </td>
          </tr> -->
          <tr class="text-center">
            <td class="input-group input-group-sm">
              <input tabindex="2" [attr.disabled]="durationDataElement.isEditable == false ? 'disabled' : null"
                formControlName="durationhourselement" [(ngModel)]="hoursvalue" class="form-control text-center txt-duration"
                (blur)="checkValue($event,'hour')" type="number" min="{{supportedUnits['hour'].min}}" max="{{supportedUnits['hour'].max}}"
                (keypress)="onlyInteger($event)" onpaste="return false;" required />
              <span class="input-group-addon" style="padding: 5px;">{{supportedUnits['hour'].label}}</span>
            </td>
          </tr>
          <!-- <tr class="text-center">
            <td>
              <button type="button" (click)="decreaseValue('hour')" class="btn btn-link btn-decrementer">
                -
              </button>
            </td>
          </tr> -->
        </tbody>
      </table>

      <table style="margin-left:10px;">
        <tbody>
          <!-- <tr class="text-center">
            <td>
              <button type="button" (click)="increaseValue('minute')" class="btn btn-link btn-decrementer">
                +
              </button>
            </td>
          </tr> -->
          <tr class="text-center">
            <td class="input-group input-group-sm">
              <input tabindex="3" [(ngModel)]="minutesvalue" formControlName="durationminuteselement" [attr.disabled]="durationDataElement.isEditable == false ? 'disabled' : null"
                class="form-control text-center txt-duration" (blur)="checkValue($event, 'minute')" type="number" min="{{supportedUnits['minute'].min}}"
                max="{{supportedUnits['minute'].max}}" (keypress)="onlyInteger($event)" onpaste="return false;" required />
              <span class="input-group-addon" style="padding: 5px;">{{supportedUnits['minute'].label}}</span>
            </td>
          </tr>
          <!-- <tr class="text-center">
            <td>
              <button type="button" (click)="decreaseValue('minute')" class="btn btn-link btn-decrementer">
                -
              </button>
            </td>
          </tr> -->
        </tbody>
      </table>

      <!-- </div> -->


    </div>
  </div>
</form>`,
  styles: [`.required-field{color:red}.disabled-picker{cursor:not-allowed}.disabled-picker:before{content:"";z-index:1;position:absolute;top:0;right:0;bottom:0;left:0;background-color:rgba(255,255,255,.8)}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{text-align:center}.btn-decrementer,.btn-incrementer{text-decoration:none;outline:0}.txt-duration{width:42px}.btn.active.focus,.btn.active:focus,.btn.focus,.btn:active.focus,.btn:active:focus,.btn:focus{outline:0!important;outline-offset:-2px}`]
})
export class AssistDurationElementComponent implements OnInit {
  @Input() durationDataElement: DurationDataElement;
  durationElementForm: FormGroup;
  subscription: Subscription;

  supportedUnits: any = {
    millisecond: {
      'label': 'Millisecond',
      'max': 999,
      'min': 0,
      'value': 0,
      'step': 1
    },
    second: {
      'label': 'Second',
      'max': 59,
      'min': 0,
      'value': 0,
      'step': 1
    },
    minute: {
      'label': 'Minutes',
      'max': 59,
      'min': 0,
      'value': 0,
      'step': 1
    },
    hour: {
      'label': 'Hours',
      'max': 23,
      'min': 0,
      'value': 0,
      'step': 1
    },
    day: {
      'label': 'Days',
      'max': 7,
      'min': 0,
      'value': 0,
      'step': 1
    },
    week: {
      'label': 'Week',
      'max': 51,
      'min': 0,
      'value': 0,
      'step': 1
    }
  };

  daysvalue = 0;
  hoursvalue = 0;
  minutesvalue = 0;

  constructor(private formBuilder: FormBuilder, private simulatorEngineService: SimulatorEngineService,
    simulatorCommunicationService: SimulatorCommunicationService) {
    this.subscription = simulatorCommunicationService.simulatorSource$.subscribe(
      mission => {
        this.SetRangeValuesForDurationPicker();
        this.UpdateFormValidator();
      });
  }



  DurationVal = 'PT0S';
  durationOptions = {
    showNegative: false,
    showPreview: false,
    showYears: false,
    showMonths: false,
    showWeeks: false,
    min: 0
  };

  showdayminValidation = false;
  showdaymaxValidation = false;
  showminutemaxValidation = false;
  showminuteminValidation = false;
  showhourminValidation = false;
  showhourmaxValidation = false;

  ngOnInit() {
    this.SetRangeValuesForDurationPicker();
    this.createDurationElementForm();
    this.onChanges();
  }

  ResetValidationVisibility(): void {
    this.showdayminValidation = false;
    this.showdaymaxValidation = false;
    this.showminutemaxValidation = false;
    this.showminuteminValidation = false;
    this.showhourminValidation = false;
    this.showhourmaxValidation = false;
  }

  onChanges(): void {
    this.durationElementForm.statusChanges
      .subscribe(val => {
        this.ResetValidationVisibility();
        if (this.durationElementForm.controls['durationdayselement'].invalid
          && this.durationElementForm.controls['durationdayselement'].errors.max) {
          this.showdaymaxValidation = true;
        } else if (this.durationElementForm.controls['durationdayselement'].invalid
          && this.durationElementForm.controls['durationdayselement'].errors.min) {
          this.showdayminValidation = true;
        } else if (this.durationElementForm.controls['durationminuteselement'].invalid
          && this.durationElementForm.controls['durationminuteselement'].errors.min) {
          this.showminuteminValidation = true;
        } else if (this.durationElementForm.controls['durationminuteselement'].invalid
          && this.durationElementForm.controls['durationminuteselement'].errors.max) {
          this.showminutemaxValidation = true;
        } else if (this.durationElementForm.controls['durationhourselement'].invalid
          && this.durationElementForm.controls['durationhourselement'].errors.min) {
          this.showhourminValidation = true;
        } else if (this.durationElementForm.controls['durationhourselement'].invalid
          && this.durationElementForm.controls['durationhourselement'].errors.max) {
          this.showhourmaxValidation = true;
        }
      });
  }

  private SetRangeValuesForDurationPicker() {
    const $element = this.durationDataElement;
    this.supportedUnits['day'].min = $element.MinimumDay !== undefined && $element.MinimumDay != null ?
      $element.MinimumDay : 0;
    this.supportedUnits['hour'].min = $element.MinimumHours !== undefined && $element.MinimumHours != null ?
      $element.MinimumHours : 0;
    this.supportedUnits['minute'].min = $element.MinimumMinutes !== undefined && $element.MinimumMinutes != null ?
      $element.MinimumMinutes : 0;
    this.supportedUnits['day'].max = $element.MaximumDay !== undefined && $element.MaximumDay != null ?
      $element.MaximumDay : 9007199254740991;
    this.supportedUnits['hour'].max = $element.MaximumHours !== undefined && $element.MaximumHours != null ?
      $element.MaximumHours : 9007199254740991;
    this.supportedUnits['minute'].max = $element.MaxmimumMinutes !== undefined && $element.MaxmimumMinutes != null ?
      $element.MaxmimumMinutes : 9007199254740991;
  }

  private createDurationElementForm() {
    this.durationElementForm = this.formBuilder.group({
      durationdayselement: ['', Validators.compose([Validators.required,
      Validators.min(+this.supportedUnits['day'].min), Validators.max(+this.supportedUnits['day'].max)])],
      durationminuteselement: ['', Validators.compose([Validators.required,
      Validators.min(+this.supportedUnits['minute'].min), Validators.max(+this.supportedUnits['minute'].max)])],
      durationhourselement: ['', Validators.compose([Validators.required,
      Validators.min(+this.supportedUnits['hour'].min), Validators.max(+this.supportedUnits['hour'].max)])]
      // durationdayselement: ['', Validators.compose([Validators.required])],
    });
  }

  onlyInteger(event) {
    return (event.charCode === 8 || event.charCode === 0) ? null : event.charCode >= 48 && event.charCode <= 57;
  }

  UpdateFormValidator() {
    this.durationElementForm.controls['durationdayselement'].setValidators([Validators.compose([Validators.required,
    Validators.min(+this.supportedUnits['day'].min), Validators.max(+this.supportedUnits['day'].max)])]);
    this.durationElementForm.controls['durationdayselement'].updateValueAndValidity();

    this.durationElementForm.controls['durationminuteselement'].setValidators([Validators.compose([Validators.required,
    Validators.min(+this.supportedUnits['minute'].min), Validators.max(+this.supportedUnits['minute'].max)])]);
    this.durationElementForm.controls['durationminuteselement'].updateValueAndValidity();

    this.durationElementForm.controls['durationhourselement'].setValidators([Validators.compose([Validators.required,
    Validators.min(+this.supportedUnits['hour'].min), Validators.max(+this.supportedUnits['hour'].max)])]);
    this.durationElementForm.controls['durationhourselement'].updateValueAndValidity();
  }

  public increaseValue(property): void {
    let currentValue = 0;
    switch (property) {
      case 'days':
        currentValue = this.daysvalue === undefined || this.daysvalue == null ? 0 : this.daysvalue;
        if (currentValue < this.supportedUnits['day'].max) {
          currentValue = currentValue + this.supportedUnits['day'].step;
        }

        this.daysvalue = currentValue;
        break;

      case 'hour':
        currentValue = this.hoursvalue === undefined || this.hoursvalue == null ? 0 : this.hoursvalue;
        if (currentValue < this.supportedUnits['hour'].max) {
          currentValue = currentValue + this.supportedUnits['hour'].step;
        }

        this.hoursvalue = currentValue;
        break;

      case 'minute':
        currentValue = this.minutesvalue === undefined || this.minutesvalue == null ? 0 : this.minutesvalue;
        if (currentValue < this.supportedUnits['minute'].max) {
          currentValue = currentValue + this.supportedUnits['minute'].step;
        }

        this.minutesvalue = currentValue;
        break;
    }
  }

  public decreaseValue(property): void {
    let currentValue = 0;
    switch (property) {
      case 'days':
        currentValue = this.daysvalue;
        if (currentValue > this.supportedUnits['day'].min) {
          currentValue = currentValue - this.supportedUnits['day'].step;
        }

        this.daysvalue = currentValue;
        break;

      case 'hour':
        currentValue = this.hoursvalue;
        if (currentValue > this.supportedUnits['hour'].min) {
          currentValue = currentValue - this.supportedUnits['hour'].step;
        }

        this.hoursvalue = currentValue;
        break;

      case 'minute':
        currentValue = this.minutesvalue;
        if (currentValue > this.supportedUnits['minute'].min) {
          currentValue = currentValue - this.supportedUnits['minute'].step;
        }

        this.minutesvalue = currentValue;
        break;
    }
  }

  checkValue(event: any, property) {
    let currentValue = 0;
    switch (property) {
      case 'days':
        currentValue = this.daysvalue;
        if (currentValue === undefined || currentValue == null) {
          currentValue = 0;
        }

        this.daysvalue = currentValue;
        break;

      case 'hour':
        currentValue = this.hoursvalue;
        if (currentValue === undefined || currentValue == null) {
          currentValue = 0;
        }

        this.hoursvalue = currentValue;
        break;

      case 'minute':
        currentValue = this.minutesvalue;
        if (currentValue === undefined || currentValue == null) {
          currentValue = 0;
        }

        this.minutesvalue = currentValue;
        break;
    }
  }

  // tslint:disable-next-line:use-life-cycle-interface
  ngOnDestroy() {
    // prevent memory leak when component destroyed
    this.subscription.unsubscribe();
  }
}



